type IpAddressResult = { ip: string | null };

export const getIpAddress = async () => {
  try {
    const response = await fetch('/api/ip');
    if (response.status !== 200) {
      throw new Error('Error. Cannot fetch ip address.');
    }

    const result: IpAddressResult = await response.json();

    return result.ip;
  } catch (err) {
    console.warn((err as Error).message);
    return null;
  }
};
